import Vue from 'vue';
class Phone {
  constructor(
    code,
    phoneToken,
    phoneNumber,
    sendLocation,
    missionInterval,
    readyInterval,
    ipAddress,
    useAPN,
    emsHelperId,
    stationId,
    isEmsHelper,
    vehicleTypeId,
  ) {
    this.code = code;
    this.phoneToken = phoneToken;
    this.phoneNumber = phoneNumber;
    this.sendLocation = sendLocation;
    this.missionInterval = missionInterval;
    this.readyInterval = readyInterval;
    this.ipAddress = ipAddress;
    this.useAPN = useAPN;
    this.emsHelperId = emsHelperId;
    this.stationId = stationId;
    this.isEmsHelper = isEmsHelper;
    this.vehicleTypeId = vehicleTypeId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allPhones: [],
      allPhonesForOther: [],
      phone: new Phone('', '', '', false, null, null, '', false, null, null, false, null),
      phonePaginationList: [],
    };
  },
  methods: {
    getListOfPhonesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPhones').then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          this.allPhonesForOther = this.$store.state.phoneModule.allPhones;
          if (this.$route.name == 'user') {
            this.allUserPhones = this.allPhonesForOther;
            this.readyUserPhone();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfPhonesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfPhonesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPhones: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPhones').then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          this.allPhones = this.$store.state.phoneModule.allPhones;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllPhones();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllPhones();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfPhonesWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let searchIsBroken = null;
      if (this.searchIsBroken == 2) {
        searchIsBroken = true;
      } else if (this.searchIsBroken == 3) {
        searchIsBroken = false;
      }
      let searchIsActive = null;
      if (this.searchIsActive == 2) {
        searchIsActive = true;
      } else if (this.searchIsActive == 3) {
        searchIsActive = false;
      }
      let searchUseAPN = null;
      if (this.searchUseAPN == 2) {
        searchUseAPN = true;
      } else if (this.searchUseAPN == 3) {
        searchUseAPN = false;
      }
      this.$store
        .dispatch('getPhonesWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          code: this.searchCode,
          isActive: searchIsActive,
          isBroken: searchIsBroken,
          phoneToken: this.searchPhoneToken,
          iPAddress: this.searchIPAddress,
          useAPN: searchUseAPN,
        })
        .then(() => {
          if (this.$store.state.phoneModule.successFlag) {
            this.phonePaginationList = [];
            let temp = this.$store.state.phoneModule.phones;
            for (let i = 0; i < temp.length; i++) {
              this.phonePaginationList.push({
                code: temp[i].code ? temp[i].code : '-',
                phoneToken: temp[i].phoneToken ? temp[i].phoneToken : '-',
                phoneNumber: temp[i].phoneNumber ? temp[i].phoneNumber : '-',
                ipAddress: temp[i].ipAddress ? temp[i].ipAddress : '-',
                vehicleType: temp[i].vehicleType ? temp[i].vehicleType.title : '-',
                station: temp[i].station ? temp[i].station.title : '-',
                apn: temp[i].useAPN,
                location: temp[i].sendLocation,
                id: temp[i].id,
                locationIn: temp[i].missionInterval ? temp[i].missionInterval : '-',
                locationOut: temp[i].readyInterval ? temp[i].readyInterval : '-',
                isActive: temp[i]?.isActive,
                applicationVersion: temp[i]?.applicationVersion || '-',
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.phoneModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.phoneModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.phoneModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.phoneModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfPhonesWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.phoneModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfPhonesWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addPhoneFunction: function () {
      if (!this.phone.code) {
        this.snackText = 'کد نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.phone.vehicleTypeId) {
        this.snackText = 'نوع وسیله نقلیه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.phone.stationId) {
        this.snackText = 'پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.phone.useAPN == true) {
        if (!this.phone.ipAddress) {
          this.snackText = 'آدرس Ip نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPhone', this.phone).then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' گوشی با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.phone = new Phone('', '', '', false, null, null, '', false, null, null, false, null);
          this.getListOfPhonesWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addPhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addPhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPhoneFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPhone', id).then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          let temp = this.$store.state.phoneModule.phone;
          this.phone.id = temp.id;
          this.phone.code = temp.code;
          this.phone.phoneToken = temp.phoneToken;
          this.phone.phoneNumber = temp.phoneNumber;
          this.phone.sendLocation = temp.sendLocation;
          this.phone.missionInterval = temp.missionInterval;
          this.phone.readyInterval = temp.readyInterval;
          this.phone.ipAddress = temp.ipAddress;
          this.phone.useAPN = temp.useAPN;
          this.phone.stationId = temp.station.id;
          this.phone.isEmsHelper = temp.isEmsHelper;
          this.phone.vehicleTypeId = temp.vehicleType.id;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPhoneFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getPhoneFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editPhoneFunction: function () {
      if (!this.phone.code) {
        this.snackText = 'کد شبرنگ نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.phone.vehicleTypeId) {
        this.snackText = 'نوع وسیله نقلیه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.phone.stationId) {
        this.snackText = 'پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.phone.useAPN == true) {
        if (!this.phone.ipAddress) {
          this.snackText = 'آدرس Ip نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editPhone', this.phone).then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfPhonesWithPagination();
          this.snackText = ' گوشی با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.phone = new Phone('', '', '', false, null, null, '', false, null, null, false, null);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editPhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editPhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deletePhoneFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deletePhone', this.phoneId).then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfPhonesWithPagination();
          this.snackText = ' گوشی با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deletePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deletePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    activatePhone: function () {
      this.load.val = true;
      const params = { phoneId: this.phoneId };
      this.$store
        .dispatch('activatePhoneDispatch', params)
        .then(() => {
          if (this.$store.state.phoneModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            this.getListOfPhonesWithPagination();
            this.snackText = ' گوشی با موفقیت فعال شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
          } else {
            this.disabelConfirm = false;

            if (this.$store.state.phoneModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.activatePhoneFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.phoneModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.activatePhoneFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    deactivatePhone: function () {
      this.load.val = true;
      const params = { phoneId: this.phoneId };
      this.$store
        .dispatch('deactivatePhoneDispatch', params)
        .then(() => {
          if (this.$store.state.phoneModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            this.getListOfPhonesWithPagination();
            this.snackText = 'گوشی با موفقیت غیرفعال شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
          } else {
            this.disabelConfirm = false;

            if (this.$store.state.phoneModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deactivatePhoneFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.phoneModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deactivatePhoneFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    getListOfReadyPhonesFor800Function: function () {
      this.$store.dispatch('getListOfReadyPhone').then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          let temp = this.$store.state.phoneModule.readyPhones;
          if (this.sendTOPhoneModal == true) {
            this.readyPhonesList = temp;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfReadyPhonesFor800Function();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfReadyPhonesFor800Function();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfTopNearestPhonesFor800Function: function (lat, lng) {
      this.topNearestCodeList = [];
      this.topNearestLoaderFlag = true;
      this.$store.dispatch('getListOfTopNearestPhone', { lat: lat, lng: lng }).then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          let temp = this.$store.state.phoneModule.topNearestPhones;
          if (this.sendTOPhoneModal == true) {
            this.topNearestCodeList = temp;
          }
          this.topNearestLoaderFlag = false;
        } else {
          this.topNearestLoaderFlag = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfTopNearestPhonesFor800Function(lat, lng);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfTopNearestPhonesFor800Function(lat, lng);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfReadyPhonesBy800UserFunction: function (stationId) {
      this.readyPhonesByStationList = [];
      this.topNearestFenceLoaderFlag = true;
      this.$store.dispatch('getListOfReadyPhoneByStation', stationId).then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          let temp = this.$store.state.phoneModule.readyPhonesByStation;
          if (this.sendTOPhoneModal == true) {
            this.readyPhonesByStationList = temp;
          }
          this.topNearestFenceLoaderFlag = false;
        } else {
          this.topNearestFenceLoaderFlag = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfReadyPhonesBy800UserFunction(stationId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfReadyPhonesBy800UserFunction(stationId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfPhonesActivityReport: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPhonesActivityReport').then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          this.listOfCodesFor800AmbulanceList = [];
          let temp = this.$store.state.phoneModule.phonesActivityReportList;
          for (let i = 0; i < temp.length; i++) {
            let loginDate = '-';
            if (temp[i].startDate) {
              loginDate = Vue.moment(temp[i].startDate).format('HH:mm:ss jYYYY/jM/jD');
            }
            this.listOfCodesFor800AmbulanceList.push({
              phoneCode: temp[i].phone ? temp[i].phone.code : '-',
              codeType: temp[i].phone ? temp[i].phone.vehicleType : '-',
              missionCount: temp[i].missionsCount ? temp[i].missionsCount : 0,
              loginDate: loginDate,
              zone: temp[i].phone ? temp[i].phone.zone : '-',
              shabrangCode: temp[i].vehicleCode ? temp[i].vehicleCode : '-',
              seniorUser: temp[i].firstUser ? temp[i].firstUser : '-',
              firstUser: temp[i].secondUser ? temp[i].secondUser : '-',
              note: temp[i].note ? temp[i].note : '-',
              phoneNumber: temp[i].phone ? temp[i].phone.phoneNumber : '-',
              id: temp[i].id,
              hasMission: temp[i].phone ? temp[i].phone.hasMission : false,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfPhonesActivityReport();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfPhonesActivityReport();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfUsersPhoneActivityReport: function (phoneActivityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getUsersActivityReport', phoneActivityId).then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          let temp = this.$store.state.phoneModule.phoneUsersActivityReportList;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name === 'phoneActivityDetailReport') {
            this.makeDataReady(temp);
            return;
          }
          this.makeReadyMoreInfoData(temp);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfUsersPhoneActivityReport(phoneActivityId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfUsersPhoneActivityReport(phoneActivityId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    positionRequestFunction: function (phoneId) {
      this.$store.dispatch('positionRequest', phoneId).then(() => {
        if (this.$store.state.phoneModule.successFlag) {
          this.snackText = ' درخواست با موفقیت ارسال شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          if (this.$store.state.phoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.positionRequestFunction(phoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.positionRequestFunction(phoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.phoneModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
